// stores/blobStore.js
import { defineStore } from "pinia";

export const useBlobStore = defineStore("blobStore", {
	state: () => ({
		blob_files: {}, // ファイル一覧
		uploadHistory: {}, // アップロード履歴
		summaryInfo: {}, // 要約ファイルダウンロードURL
	}),
	actions: {
		setItems(blobs) {
			if (typeof blobs === "object" && blobs !== null) {
				this.blob_files = {}; // 初期化

				// blobsをディレクトリごとに整理
				Object.entries(blobs).forEach(([directory, files]) => {
					// blobsをそのまま格納
					this.blob_files[directory] = [...files]; // ファイルのパスをそのまま格納する
				});
			} else {
				console.error("Invalid data format for blobs:", blobs);
				this.blob_files = {}; // 空にするか、デフォルトの値を設定
			}
		},
		checkFileExists(fileName) {
			if (Array.isArray(this.blob_files)) {
				return this.blob_files.some((blob) => blob === fileName); // 配列の中の同名ファイルを確認
			}
			return false; // blob_files が配列でない場合は false を返します
		},
		setUploadHistory(histories) {
			this.uploadHistory = {}; // 初期化
			// 履歴をディレクトリごとにグループ化
			histories.forEach((history) => {
				if (!this.uploadHistory[history.directory]) {
					this.uploadHistory[history.directory] = []; // 初めてのディレクトリの場合、初期化
				}
				// ディレクトリに必要な情報を追加
				this.uploadHistory[history.directory].push({
					file_name: history.file_name,
					upload_date: history.upload_date,
					user_name: history.user_name,
					field_id: history.field_id,
				});
			});

			// 各ディレクトリのuploadHistoryを日付でソート
			Object.keys(this.uploadHistory).forEach((directory) => {
				this.uploadHistory[directory].sort((a, b) => {
					return new Date(b.upload_date) - new Date(a.upload_date); // 新しい日付が先に来るようにソート
				});
			});
		},
		setSummaryInfo(data) {
			this.summaryInfo = data;
		},
		clearSummaryInfo() {
			this.summaryInfo = {};
		},
	},
});
